// extracted by mini-css-extract-plugin
module.exports = {"map":"EnterPageOld_map__9xF9-","wrapper":"EnterPageOld_wrapper__2tQhb","frame-scroll":"EnterPageOld_frame-scroll__1hG1s","frame-image":"EnterPageOld_frame-image__1YVrq"};